import APIMessageRepository from './APIMessageRepository';

export default {

    mounted() {

        this.countOccur = this.$refs.countOccur;
        this.currentOccur = this.$refs.currentOccur;
    
        this.$root.$on("component_message", message => {
          let nMessages = this.messages.length;
    
          this.messages.push({
            id: (nMessages += 1),
            user: "user",
            content: message,
            type: "simple"
          });
          this.typing = false;
        });
    
        this.$root.$on("writing_message", () => {
          this.typing = true;
          this.scrollToEnd()
        });
    
        this.$root.$on("deleted_message", () => {
          this.typing = false;
        }), 
    
        this.$root.$on("add_tomessage", message => {
          this.messages.push(message)
          this.scrollToEnd()
        }), 

        this.$root.$on("addMessagesFromServer", conversationid => {  

          // se la conversazione non è nella lista attuale ricarico la lista


          if(this.currentConversationId!=conversationid) {  
            this.$root.$emit("addNotifyFromServer",conversationid )
            return
          }             
                    
          let params = { 
            'filter': {
              'after_message': this.lastMessageId
            },
            'sort': 'created_at'
          }

          this.updateMessages(params).then((messages)=>{  
            setTimeout(function(){ this.scrollToEnd()}.bind(this), 500);                             
          })          

        }),                 
    
        this.$root.$on('changeMsgContainer', function(conversation,searchString){        
          this.searchString = searchString
          if (searchString=='') this.countOccur=0              

              this.currentConversationId = conversation.id 

              let params = { 
                'sort': '-created_at',
                //'page':{'size':30,'number':1},    
              }

              this.isLoading = true
              this.fetchMessage(params).then((res)=>{  
                  this.isLoading = false                                                                                  
                  this.$root.$emit("manageChatStatus",conversation.manual,conversation.id);                          
                  setTimeout(function(){ this.scrollToEnd()}.bind(this), 500); 
              })                                               
            
        }.bind(this)),

        this.$root.$on('deleteMsgContainer', function(){
            this.isLoading = false            
            this.messages = []       
        }.bind(this))
      },    
    
    methods: {
      
        updateMessages(params){

          return new Promise((resolve, reject) =>{             
           this.fetchMessage(params,true,true).then((res)=>{              
            resolve(true)                      
           })

          })

        },

        ifMessageExists(id){

          return new Promise((resolve, reject) =>{  
            
            if (this.messages.length==0) resolve(false);

            /*
            // via ARRAY
            for(var i=0,l=this.messages.length;i<l;i++){
              if(this.messages[i].id == id){
                console.log('esiste')
                resolve(true);
              } 
              resolve(false);
            }    
            */

            // via DOM
           var element = (document.getElementById(id))
            if(typeof(element) != 'undefined' && element != null){
              resolve(true)
            }else{
              resolve(false);
            }

          })
          
        },

        fetchMessage(params,addMessages=false,addAtEnd=false) {

            this.countOccur=0 
            this.currentOccur=1  
    
            return new Promise((resolve, reject) =>{                                                                           
                APIMessageRepository.getMessages(this.currentConversationId,params).then((res)=>{
                                                                
                  if (!addMessages) this.messages = []                                          
                  res.response.data.map((value)=> {  
                                                    
                      this.ifMessageExists( value.message.id).then((messegeExists)=>{
                                                                      
                        if (!messegeExists){
      
                          if(this.searchString=='' ){
                            if (addAtEnd){
                              this.messages.push(value.message)
                                
                            }else{
                              this.messages.unshift(value.message)                                                      
                            }                  
                          }else{
                            
                              switch (value.message.type) {
            
                                case "browserCarousel":                           
                                  value.message.content.items.map((subvalue, subkey)=> {                                
                                      subvalue.title = this.highlight(subvalue.title) 
                                      subvalue.description = this.highlight(subvalue.description)                               
                                  })                          
                                break;
            
                                case "simpleText":                         
                                    value.message.content.text  = this.highlight(value.message.content.text)                                             
                                break;
            
                                case "tablecard":   
                                  value.message.content.title  = this.highlight(value.message.content.title)                       
                                break;    
                                
                                case "linkout":   
                                  value.message.content.title  = this.highlight(value.message.content.title)                       
                                break;    
                                
                                case "register":   
                                  value.message.content.title  = this.highlight(value.message.content.title)                       
                                break;   
                                                    
                                case "html":   
                                  value.message.content  = this.highlight(value.message.content)                       
                                break;                         
                                
                              }  
                                      
                              if (addAtEnd){
                                this.messages.push(value.message)                                
                              }else{
                                this.messages.unshift(value.message)                                                                  
                              }  
            
                          } 
                        } 

                      })
                            
                  });        
                  
                  if(res.response.data.length>0){                                      
                      if (res.response.meta.last_page>1){
                        this.blockTopPagination = false;                                                                            
                      } else{
                        this.blockTopPagination = true;                                                                            
                      }                        
                      this.firstMessageId = res.response.data[res.response.data.length-1].id   
                      this.lastMessageId = res.response.data[0].id                             
                  }
                                                                                           
                  resolve(true)                       

                })
                
                resolve(false)
            })
          },        

        highlight(message){        
            return message.replace(new RegExp(this.searchString, "gi"), match => {            
                this.countOccur++;                    
                let html = '<span id="occur_' + this.countOccur + '" class="highlightText'
                if(this.countOccur==1) html += ' highselected'
                html += '">' + match + '</span>'          
                return html
            });

            
        },
        getParentWithClass(anc){
            return document.getElementById(anc).closest(".messages")
        },
        prevOccur(anc){ 

            document.getElementById("occur_" + this.currentOccur).classList.remove("highselected")

            if (this.currentOccur>1){
                this.currentOccur--
            }else{
                this.currentOccur=this.countOccur
            }    
            
            this.jumptoanchor("occur_" + this.currentOccur);
                
        },
        nextOccur(){

            document.getElementById("occur_" + this.currentOccur).classList.remove("highselected")

            if (this.currentOccur<this.countOccur){
                this.currentOccur++
            }else{
                this.currentOccur=1        
            }  
                    
            this.jumptoanchor("occur_" + this.currentOccur);      
        
        },
        jumptoanchor(anc){        
                    
            document.getElementById(anc).classList.add("highselected")
            let st = this.getParentWithClass(anc).getBoundingClientRect().top + document.getElementById("messageContainer").scrollTop - 100
            document.getElementById("messageContainer").scrollTop = st
            
        },
        closeSearch(){
            this.searchString=''
            this.countOccur=0 
            this.$root.$emit("resetSearch",true); 
        },
        scrollToEnd(){                        
            if (document.getElementById("messageContainer")) document.getElementById("messageContainer").scrollTop = document.getElementById("messageContainer").scrollHeight +100;                                                                               
        },
        scrollToTop(){                          
            if (document.getElementById("messageContainer")) document.getElementById("messageContainer").scrollTop = 1;                                                                               
        },        
        prevPage(){

          if(this.blockTopPagination || this.messages.length==0) return false             
                              
          let params = { 
            'filter': {
              'before_message': this.firstMessageId
            },
            'sort': '-created_at'
          }

          this.isLoadingPreviousMessages=true
          this.fetchMessage(params,true,false).then((res)=>{                                                          
              setTimeout(function(){ this.scrollToTop();this.isLoadingPreviousMessages = false}.bind(this), 500); 
          })      
          
        }

    }
}